import * as ActionDetailBranch from '../../../../core/action/Branch/ActionDetailBranch';
import * as Branch from '../../../../core/action/Branch/ActionAllBranch';
import * as actionGenerateCourierCode from '../../../../core/action/ManageAccount/Courier/ActionGenerateCourierCode';
import * as addCourier from '../../../../core/action/ManageAccount/Courier/ActionAddCourier';
import * as formCourier from '../../../../core/action/ManageAccount/Courier/ActionFormDetailCourier';
import * as toggle from '../../../../core/action/toggle';

import React, { Component } from 'react';
import { bindActionCreators, compose } from 'redux';

import AddCourierComponent from '../../../../components/Content/ManageAccount/Courier/AddCourierComponent';
import { connect } from 'react-redux';
import moment from 'moment';

interface IProps {
  actionToggle: any;
  visible: any;
  jenisToggle: any;
  actionFormCourier: any;
  actionBranch: any;
  actionDetailBranch: any;
  BranchList: any;

  GetCourierName: any;
  GetCourierLastName: any;
  GetCourierEmail: any;
  GetCourierPhoneNumber: any;
  GetCourierDob: any;
  GetCourierPhoto: any;
  GetCourierCode: any;
  GetCourierAddress: any;
  GetCourierStatus: any;

  roleAccount: any;
  branchAuth: any;

  GetCourierAreaCode: any;

  addCourier: any;
  generateCourierCode: any;

  isLoading: any;
  LoadingSelectBranch: any;
  TypeLoadingSelectBranch: any;
}

interface IState {
  ValidateCourierName: any;
  ValidateCourierLastName: any;
  ValidateCourierEmail: any;
  ValidateCourierPhoneNumber: any;
  ValidateCourierDob: any;
  ValidateCourierPhoto: any;
  ValidateCourierCode: any;
  ValidateCourierBranchArea: any;
  ValidateCourierAddress: any;
  ValidateDob: any;
  StateDobCourier: any;
}

class AddCourierContainer extends Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      ValidateCourierName: null,
      ValidateCourierLastName: null,
      ValidateCourierEmail: null,
      ValidateCourierPhoneNumber: null,
      ValidateCourierDob: null,
      ValidateCourierPhoto: null,
      ValidateCourierAddress: null,
      ValidateCourierCode: null,
      ValidateCourierBranchArea: null,
      ValidateDob: null,
      StateDobCourier: null,
    };
    this.handleClearDetailCourier = this.handleClearDetailCourier.bind(this);
    this.handleGetBranch = this.handleGetBranch.bind(this);
    this.handlePutCourierName = this.handlePutCourierName.bind(this);
    this.handlePutCourierLastName = this.handlePutCourierLastName.bind(this);
    this.handlePutCourierEmail = this.handlePutCourierEmail.bind(this);
    this.handlePutCourierPhoneNumber =
      this.handlePutCourierPhoneNumber.bind(this);
    this.handlePutCourierDob = this.handlePutCourierDob.bind(this);
    this.handlePutCourierPhoto = this.handlePutCourierPhoto.bind(this);
    this.handlePutCourierCode = this.handlePutCourierCode.bind(this);
    this.handlePutAreaCode = this.handlePutAreaCode.bind(this);
    this.handleGenerateCourierCode = this.handleGenerateCourierCode.bind(this);
    this.handleSaveCourier = this.handleSaveCourier.bind(this);
    this.handleValidateDob = this.handleValidateDob.bind(this);
    this.handleBlurAreaCode = this.handleBlurAreaCode.bind(this);
    this.handlePutAddress = this.handlePutAddress.bind(this);
    this.handleCheckBox = this.handleCheckBox.bind(this);
  }

  handleClearDetailCourier() {
    this.props.actionToggle.changeModal();
    this.props.actionToggle.clearJenisToggle();
    this.props.actionBranch.clearBranch();
    this.props.actionDetailBranch.setBranchDetail(null);
    this.props.actionFormCourier.changeClearDataCourierForm();
    this.setState({
      ValidateCourierName: '',
      ValidateCourierLastName: '',
      ValidateCourierEmail: '',
      ValidateCourierPhoneNumber: '',
      ValidateCourierDob: '',
      ValidateCourierPhoto: '',
      ValidateCourierCode: '',
      ValidateCourierBranchArea: '',
      ValidateCourierAddress: '',
      StateDobCourier: null,
    });
  }

  handleCheckBox(event: any) {
    if (event.target.checked === true) {
      this.props.actionFormCourier.changeCourierStatus(1);
    } else {
      this.props.actionFormCourier.changeCourierStatus(0);
    }
  }

  handleGetBranch() {
    this.props.actionBranch.getAllBranch();
  }

  handlePutCourierName(event: any) {
    this.props.actionFormCourier.changeCourierName(event.target.value);
    const RegexMinChar = /(?=^.{3,}$)/;
    if (event.target.value === '') {
      this.setState({
        ValidateCourierName: 'error',
      });
    } else if (!RegexMinChar.test(event.target.value)) {
      this.setState({
        ValidateCourierName: 'minchar',
      });
    } else {
      this.setState({
        ValidateCourierName: '',
      });
    }
  }

  handlePutCourierLastName(event: any) {
    this.props.actionFormCourier.changeCourierLastName(event.target.value);
    const RegexMinChar = /(?=^.{3,}$)/;
    if (event.target.value === '') {
      this.setState({
        ValidateCourierLastName: 'error',
      });
    } else if (!RegexMinChar.test(event.target.value)) {
      this.setState({
        ValidateCourierLastName: 'minchar',
      });
    } else {
      this.setState({
        ValidateCourierLastName: '',
      });
    }
  }

  handlePutCourierEmail(event: any) {
    const RegexEmail = /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/;

    this.props.actionFormCourier.changeCourierEmail(event.target.value);

    if (event.target.value === '') {
      this.setState({
        ValidateCourierEmail: 'error',
      });
    } else if (!RegexEmail.test(event.target.value)) {
      this.setState({
        ValidateCourierEmail: 'NotEmail',
      });
    } else {
      this.setState({
        ValidateCourierEmail: '',
      });
    }
  }

  handlePutCourierPhoneNumber(event: any) {
    const number = parseInt(event.target.value || 0, 10);
    const RegexPhone = /^[0-9\b]+$/;

    if (isNaN(number)) {
      return;
    }

    if (!('value' in this.props)) {
      this.props.actionFormCourier.changeCourierPhoneNumber(
        event.target.value.replace(/^0+/, '')
      );
    }

    if (event.target.value === '') {
      this.setState({
        ValidateCourierPhoneNumber: 'error',
      });
    } else if (!RegexPhone.test(event.target.value)) {
      this.setState({
        ValidateCourierPhoneNumber: 'NonNumeric',
      });
    } else {
      this.setState({
        ValidateCourierPhoneNumber: '',
      });
    }
  }

  handlePutCourierDob(event: any) {
    if (event) {
      const dateValue = event._d
        ? moment(new Date(event._d)).format('YYYY-MM-DDTHH:mm:ss')
        : event;
      this.props.actionFormCourier.changeCourierDob(dateValue);
    } else {
      this.props.actionFormCourier.changeCourierDob(null);
    }
    this.setState({
      StateDobCourier: event,
    });
    if (event === '') {
      this.setState({
        ValidateCourierDob: 'error',
      });
    } else {
      this.setState({
        ValidateCourierDob: '',
      });
    }
  }

  handleValidateDob(event: any) {
    this.setState({
      ValidateDob: event,
    });
    if (this.state.ValidateDob === true) {
      if (
        this.props.GetCourierDob === null ||
        this.props.GetCourierDob === undefined ||
        this.props.GetCourierDob === 'Invalid date'
      ) {
        this.setState({
          ValidateCourierDob: 'error',
        });
      } else {
        this.setState({
          ValidateCourierDob: '',
        });
      }
    } else {
    }
  }

  handlePutAddress(event: any) {
    this.props.actionFormCourier.changeCourierAddress(event.target.value);
    const panjang = event.target.value.length;
    if (event.target.value === '') {
      this.setState({
        ValidateCourierAddress: 'error',
      });
    } else if (panjang < 10) {
      this.setState({
        ValidateCourierAddress: 'minchar',
      });
    } else {
      this.setState({
        ValidateCourierAddress: '',
      });
    }
  }

  handlePutCourierPhoto(event: any) {
    this.props.actionFormCourier.changeCourierPhoto(event.target.value);
  }

  handlePutCourierCode(event: any) {
    this.props.actionFormCourier.changeCourierCode(event.target.value);
  }

  handlePutAreaCode(event: any) {
    this.props.actionFormCourier.changeAreaCodeId(event);
  }

  handleBlurAreaCode() {
    if (this.props.GetCourierAreaCode === null) {
      this.setState({
        ValidateCourierBranchArea: 'error',
      });
    } else {
      this.setState({
        ValidateCourierBranchArea: null,
      });
    }
  }

  handleGenerateCourierCode() {
    this.props.generateCourierCode.generateCourierCode();
  }

  handleSaveCourier() {
    this.props.addCourier.submitAddCourier();
  }

  async componentWillMount() {
    if (this.props.roleAccount === 'Branch') {
      await this.props.actionBranch.getAllBranch();
      await this.props.actionFormCourier.changeBranchCourier(
        this.props.branchAuth
      );
    }
  }

  render() {
    return (
      <div>
        <AddCourierComponent
          LoadingSelectBranch={this.props.LoadingSelectBranch}
          TypeLoadingSelectBranch={this.props.TypeLoadingSelectBranch}
          visible={
            this.props.jenisToggle === 'AddCourier' &&
            this.props.visible === true
              ? true
              : false
          }
          jenisToggle={this.props.jenisToggle}
          roleAccount={this.props.roleAccount}
          branchAuth={this.props.branchAuth}
          StateDobCourier={this.state.StateDobCourier}
          ValidateButton={
            !this.props.GetCourierName === true ||
            !this.props.GetCourierLastName === true ||
            !this.props.GetCourierAreaCode === true ||
            this.props.GetCourierDob === null ||
            this.props.GetCourierDob === 'Invalid date' ||
            !this.props.GetCourierPhoneNumber === true ||
            !this.props.GetCourierAddress === true ||
            this.state.ValidateCourierAddress === 'minchar' ||
            this.state.ValidateCourierPhoneNumber === 'NonNumeric'
              ? true
              : false
          }
          handleClearDetailCourier={this.handleClearDetailCourier}
          BranchList={this.props.BranchList}
          PutCourierName={this.handlePutCourierName}
          ValidateCourierName={
            this.state.ValidateCourierName === 'error'
              ? 'error'
              : '' || this.state.ValidateCourierName === 'minchar'
              ? 'error'
              : ''
          }
          ValidateCourierLastName={
            this.state.ValidateCourierLastName === 'error'
              ? 'error'
              : '' || this.state.ValidateCourierLastName === 'minchar'
              ? 'error'
              : ''
          }
          helpCourierName={
            this.state.ValidateCourierName === 'error'
              ? 'Nama depan wajib diisi'
              : '' || this.state.ValidateCourierName === 'minchar'
              ? 'Nama depan harus lebih dari 2 karakter'
              : ''
          }
          helpCourierLastName={
            this.state.ValidateCourierLastName === 'error'
              ? 'Nama belakang wajib diisi'
              : '' || this.state.ValidateCourierLastName === 'minchar'
              ? 'Nama belakang harus lebih dari 2 karakter'
              : ''
          }
          GetCourierName={this.props.GetCourierName}
          PutCourierLastName={this.handlePutCourierLastName}
          GetCourierLastName={this.props.GetCourierLastName}
          PutCourierEmail={this.handlePutCourierEmail}
          ValidateCourierEmail={
            this.state.ValidateCourierEmail === 'error'
              ? 'error'
              : '' || this.state.ValidateCourierEmail === 'NotEmail'
              ? 'error'
              : ''
          }
          helpCourierEmail={
            this.state.ValidateCourierEmail === 'error'
              ? 'Email Tidak Boleh Kosong'
              : '' || this.state.ValidateCourierEmail === 'NotEmail'
              ? 'Maaf format email salah'
              : ''
          }
          GetCourierEmail={this.props.GetCourierEmail}
          PutCourierPhoneNumber={this.handlePutCourierPhoneNumber}
          ValidateCourierPhoneNumber={
            this.state.ValidateCourierPhoneNumber === 'error'
              ? 'error'
              : '' || this.state.ValidateCourierPhoneNumber === 'NonNumeric'
              ? 'error'
              : ''
          }
          helpCourierPhoneNumber={
            this.state.ValidateCourierPhoneNumber === 'error'
              ? 'No Telpon wajib diisi'
              : '' || this.state.ValidateCourierPhoneNumber === 'NonNumeric'
              ? 'Tidak boleh selain angka!'
              : ''
          }
          GetCourierPhoneNumber={this.props.GetCourierPhoneNumber}
          PutCourierDob={this.handlePutCourierDob}
          ValidateCourierDob={
            this.state.ValidateCourierDob === 'error' ? 'error' : ''
          }
          helpCourierDob={
            this.state.ValidateCourierDob === 'error'
              ? 'Tanggal Lahir wajib diisi'
              : ''
          }
          handleValidateDob={this.handleValidateDob}
          PutCourierPhoto={this.handlePutCourierPhoto}
          GetCourierPhoto={this.props.GetCourierPhoto}
          PutCourierCode={this.handlePutCourierCode}
          GetCourierCode={this.props.GetCourierCode}
          PutCourierAddress={this.handlePutAddress}
          GetCourierAddress={this.props.GetCourierAddress}
          ValidateCourierAddress={
            this.state.ValidateCourierAddress === 'error'
              ? 'error'
              : '' || this.state.ValidateCourierAddress === 'minchar'
              ? 'error'
              : ''
          }
          helpCourierAddress={
            this.state.ValidateCourierAddress === 'error'
              ? 'Alamat lengkap wajib diisi'
              : '' || this.state.ValidateCourierAddress === 'minchar'
              ? 'Alamat lengkap harus lebih dari 10 karakter'
              : ''
          }
          ValueGetWilayah={
            this.props.GetCourierCode === null ? (
              <span style={{ color: '#969696' }}>Pilih wilayah HUB</span>
            ) : (
              this.props.GetCourierAreaCode
            )
          }
          handleBlurAreaCode={this.handleBlurAreaCode}
          GetCourierAreaCode={this.props.GetCourierAreaCode}
          ValidateCourierBranchArea={this.state.ValidateCourierBranchArea}
          isLoading={this.props.isLoading}
          handleGetBranch={this.handleGetBranch}
          handlePutAreaCode={this.handlePutAreaCode}
          handleGenerateCourierCode={this.handleGenerateCourierCode}
          handleSaveCourier={this.handleSaveCourier}
          handleCheckBox={this.handleCheckBox}
          GetCourierStatus={this.props.GetCourierStatus}
        />
      </div>
    );
  }
}
const mapStateToProps = (state: any) => ({
  roleAccount: state.Auth.Role,
  branchAuth: state.Auth.BranchAuth,
  visible: state.Toggle.modal,
  jenisToggle: state.Toggle.jenisToggle,
  GetCourierName: state.Courier.FormCourier.CourierName,
  GetCourierLastName: state.Courier.FormCourier.CourierLastName,
  GetCourierEmail: state.Courier.FormCourier.CourierEmail,
  GetCourierPhoneNumber: state.Courier.FormCourier.CourierPhoneNumber,
  GetCourierDob: state.Courier.FormCourier.CourierDob,
  GetCourierPhoto: state.Courier.FormCourier.CourierPhoto,
  GetCourierCode: state.Courier.FormCourier.CourierCode,
  GetCourierAreaCode: state.Courier.FormCourier.AreaCodeId,
  GetCourierAddress: state.Courier.FormCourier.CourierAddress,
  GetCourierStatus: state.Courier.FormCourier.CourierStatus,

  BranchList: state.Branch.AllBranch,

  isLoading: state.Toggle.isLoading,
  LoadingSelectBranch: state.Branch.PropertiesBranch.LoadingBranch,
  TypeLoadingSelectBranch: state.Branch.PropertiesBranch.TypeLoadingBranch,
});

const mapDispatchToProps = (dispatch: any) => ({
  actionToggle: bindActionCreators(toggle, dispatch),
  actionFormCourier: bindActionCreators(formCourier, dispatch),
  addCourier: bindActionCreators(addCourier, dispatch),
  actionBranch: bindActionCreators(Branch, dispatch),
  generateCourierCode: bindActionCreators(actionGenerateCourierCode, dispatch),
  actionDetailBranch: bindActionCreators(ActionDetailBranch, dispatch),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(AddCourierContainer);
